import { TopBar } from '../../top-bar/TopBar';
import { PublicOptions } from '../../../data/publicOptions';
import { Footer } from '../../footer/Footer';

export const AbstractInstructionsWrapper = () => {
  return (
    <>
      <TopBar options={PublicOptions} />
      <div className="content">
        <section className="snn-page-section">
          <h2 className="snn-title">Instructions for Abstract Submission – Energy Storage Discussions 2025</h2>

            <p>To submit your abstract for Energy Storage Discussions 2025, please follow the steps below:</p>

            <p>Register and Log In</p>
            <p>Access the abstract submission system by registering with your Google account or any other email address. This will allow you to log in and manage your submission.</p>

            <p>Submit Your Abstract</p>
            <p>Once logged in, click on the &quot;Submit Now&quot; or &quot;Submit Abstract&quot; tab to begin your submission.</p>

            <p>Complete the Submission Form</p>
            <p>You will be directed to an online submission template. Please fill in all required sections, including:</p>

            <ul>
                <li>Title</li>
                <li>Type of presentation (oral or poster)</li>
                <li>Authors and affiliations</li>
                <li>Introduction</li>
                <li>Methodology</li>
                <li>Results</li>
                <li>Conclusions</li>
                <li>Acknowledgments</li>
                <li>References</li>
                <li>(Optional) Image upload</li>
                <li>Preview and Submit</li>
            </ul>
            <p>
                At the bottom of the page, you will see a preview of your abstract. Please review it carefully.
                If everything looks correct, click the &quot;Submit Abstract&quot; button to complete the process.
            </p>

            <p>We look forward to receiving your contribution!</p>
        </section>
      </div>
        <Footer/>
    </>
  );
};
